import {BridgeMethod} from "@hybird/core/bridge/core";
import {cancel, invoke, on} from "@hybird/core/bridge/hybirdBridge";

export class FlutterMqtt extends BridgeMethod {

  constructor() {
    super();
  }

  connectMqtt({
                clientId = null,
                username = undefined,
                password = undefined,
                url = undefined,
                keepalive = 5,
                clean = true,
                onAutoReconnect,
                onAutoReconnected,
                onConnected,
                onDisconnected,
                onFailedConnectionAttempt,
                onMessage
              }) {
    return invoke("connectMqtt", {
      params: {
        clientId, username, password, url, keepalive, clean,
      },
      on: {
        onAutoReconnect,
        onAutoReconnected,
        onConnected,
        onDisconnected,
        onFailedConnectionAttempt,
        onMessage
      }
    })
  }

  /**
   *
   * @param clientId
   * @return {Promise<{connected,returnCode,disconnectionOrigin}>}
   */
  getMqttState({clientId}) {
    return invoke("getMqttState", {
      params: {
        clientId
      }
    })
  }

  disconnectMqtt({clientId}) {
    return invoke("disconnectMqtt", {
      params: {
        clientId
      }
    })
  }

  subscribeMqtt({clientId, topic, qos = 0}) {
    return invoke("subscribeMqtt", {
      params: {
        clientId, topic, qos
      }
    })
  }

  publishMqtt({clientId, topic, payload, qos = 0}) {
    return invoke("publishMqtt", {
      params: {
        clientId, topic, qos, payload
      }
    })
  }


  unsubscribeMqtt({clientId, topic}) {
    return invoke("unsubscribeMqtt", {
      params: {
        clientId, topic
      }
    })
  }
}

export const flutterMqtt = new FlutterMqtt();